'use strict';

module.exports = {
  BOLD: 'BOLD',
  ITALIC: 'ITALIC',
  CODE: 'CODE',
  STRIKETHROUGH: 'STRIKETHROUGH'
};